import type { GameCategory } from "./games.store";

export const VISIBLE_GAME_ROWS = 10;
export const GAME_ROW_HEIGHT = 38;
export const GAME_ROW_GAP = 4;
export const TABLE_ROW_REVEAL_DELAY_MS = 18;
export const GAME_PREFETCH_REMAINING_ROWS = 12;
export const INITIAL_GAME_ROW_REVEAL_STAGGER_MS = 28;
export const GAME_ROW_TRANSFORM_GUTTER = 12;
export const TABLE_BODY_HEIGHT = VISIBLE_GAME_ROWS * (GAME_ROW_HEIGHT + GAME_ROW_GAP);
export const TABLE_HEADER_HEIGHT = 35;

export const GAME_CATEGORIES: Array<{ id: GameCategory; label: string }> = [
  { id: "all", label: "All games" },
  { id: "rapid", label: "Rapid" },
  { id: "blitz", label: "Blitz" },
  { id: "bullet", label: "Bullet" },
  { id: "daily", label: "Daily" },
];
